var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"marker-content"},[_c('img',{attrs:{"src":_vm.iconUrl,"alt":"Marker Icon"}}),_vm._v(" "),_c('span',{staticClass:"marker-number"},[_vm._v(_vm._s(_vm.marker.id.toString()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }